export const themeConfig = {
  themeColor: "#-primary",
  direction: "ltr",
  mode: "light",
  locale: "en",
  primaryColorLevel: 500,
  cardBordered: false,
  panelExpand: false,
  controlSize: "md",
  navMode: "themed",
  layout: {
    type: "modern",
    sideNavCollapse: false,
  },
};
